/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 无数据列表 的 **请求配置**
 *
 * @分类 4225
 * @请求头 `POST /erp/NoDataGoods/noDataGoodsList`
 */
const postNoDataGoodsListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/NoDataGoods/noDataGoodsList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postNoDataGoodsList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据列表 的 **请求函数**
 *
 * @分类 4225
 * @请求头 `POST /erp/NoDataGoods/noDataGoodsList`
 */
export const postNoDataGoodsList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postNoDataGoodsListRequestConfig, requestData),
    ...args
  );
};
postNoDataGoodsList.requestConfig = postNoDataGoodsListRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 无数据商品列表-获取枚举 的 **请求配置**
 *
 * @分类 #4061
 * @请求头 `POST /erp/NoDataGoods/getNoDataGoodsListFilter`
 */
const postGetNoDataGoodsListFilterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/getNoDataGoodsListFilter",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataGoodsListFilter",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据商品列表-获取枚举 的 **请求函数**
 *
 * @分类 #4061
 * @请求头 `POST /erp/NoDataGoods/getNoDataGoodsListFilter`
 */
export const postGetNoDataGoodsListFilter = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataGoodsListFilterRequestConfig, requestData),
    ...args
  );
};
postGetNoDataGoodsListFilter.requestConfig =
  postGetNoDataGoodsListFilterRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 无数据打标-理由数据 的 **请求配置**
 *
 * @分类 5138
 * @请求头 `GET /erp/NoDataGoods/getNoDataGoodsReason`
 */
const getGetNoDataGoodsReasonRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/NoDataGoods/getNoDataGoodsReason",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetNoDataGoodsReason",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据打标-理由数据 的 **请求函数**
 *
 * @分类 5138
 * @请求头 `GET /erp/NoDataGoods/getNoDataGoodsReason`
 */
export const getGetNoDataGoodsReason = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetNoDataGoodsReasonRequestConfig, requestData),
    ...args
  );
};
getGetNoDataGoodsReason.requestConfig = getGetNoDataGoodsReasonRequestConfig;
/**
 * 接口 无数据点货-新建无数据商品 的 **请求配置**
 *
 * @分类 5138
 * @请求头 `POST /erp/NoDataGoods/createNoDataGoodsId`
 */
const postCreateNoDataGoodsIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/NoDataGoods/createNoDataGoodsId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCreateNoDataGoodsId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据点货-新建无数据商品 的 **请求函数**
 *
 * @分类 5138
 * @请求头 `POST /erp/NoDataGoods/createNoDataGoodsId`
 */
export const postCreateNoDataGoodsId = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCreateNoDataGoodsIdRequestConfig, requestData),
    ...args
  );
};
postCreateNoDataGoodsId.requestConfig = postCreateNoDataGoodsIdRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 根据无数据id获取详情 的 **请求配置**
 *
 * @分类 4243
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgid`
 */
const postGetNoDataInfoByNdgidRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/NoDataGoods/getNoDataInfoByNdgid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataInfoByNdgid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据无数据id获取详情 的 **请求函数**
 *
 * @分类 4243
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgid`
 */
export const postGetNoDataInfoByNdgid = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataInfoByNdgidRequestConfig, requestData),
    ...args
  );
};
postGetNoDataInfoByNdgid.requestConfig = postGetNoDataInfoByNdgidRequestConfig;
/**
 * 接口 获取无数据包裹信息 的 **请求配置**
 *
 * @分类 4243
 * @请求头 `POST /erp/NoDataGoods/getPackageNoShippingInfo`
 */
const postGetPackageNoShippingInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/NoDataGoods/getPackageNoShippingInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPackageNoShippingInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取无数据包裹信息 的 **请求函数**
 *
 * @分类 4243
 * @请求头 `POST /erp/NoDataGoods/getPackageNoShippingInfo`
 */
export const postGetPackageNoShippingInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPackageNoShippingInfoRequestConfig, requestData),
    ...args
  );
};
postGetPackageNoShippingInfo.requestConfig =
  postGetPackageNoShippingInfoRequestConfig;
/**
 * 接口 填写退还快递单号 的 **请求配置**
 *
 * @分类 4243
 * @请求头 `POST /erp/NoDataGoods/saveShippingNum`
 */
const postSaveShippingNumRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/NoDataGoods/saveShippingNum",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveShippingNum",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 填写退还快递单号 的 **请求函数**
 *
 * @分类 4243
 * @请求头 `POST /erp/NoDataGoods/saveShippingNum`
 */
export const postSaveShippingNum = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSaveShippingNumRequestConfig, requestData),
    ...args
  );
};
postSaveShippingNum.requestConfig = postSaveShippingNumRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 批量撤回放行退还 的 **请求配置**
 *
 * @分类 #4301
 * @请求头 `POST /erp/NoDataGoods/withdrawBackToSupply`
 */
const postWithdrawBackToSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/NoDataGoods/withdrawBackToSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postWithdrawBackToSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量撤回放行退还 的 **请求函数**
 *
 * @分类 #4301
 * @请求头 `POST /erp/NoDataGoods/withdrawBackToSupply`
 */
export const postWithdrawBackToSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postWithdrawBackToSupplyRequestConfig, requestData),
    ...args
  );
};
postWithdrawBackToSupply.requestConfig = postWithdrawBackToSupplyRequestConfig;
const mockUrl_0_0_0_5 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_5 = "";
const prodUrl_0_0_0_5 = "";
const dataKey_0_0_0_5 = "data";
/**
 * 接口 获取无数据打标ID数据 的 **请求配置**
 *
 * @分类 #5318
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgids`
 */
const postGetNoDataInfoByNdgidsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/NoDataGoods/getNoDataInfoByNdgids",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataInfoByNdgids",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取无数据打标ID数据 的 **请求函数**
 *
 * @分类 #5318
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgids`
 */
export const postGetNoDataInfoByNdgids = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataInfoByNdgidsRequestConfig, requestData),
    ...args
  );
};
postGetNoDataInfoByNdgids.requestConfig =
  postGetNoDataInfoByNdgidsRequestConfig;
const mockUrl_0_0_0_6 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_6 = "";
const prodUrl_0_0_0_6 = "";
const dataKey_0_0_0_6 = "data";
/**
 * 接口 前置仓无数据点货商品列表 的 **请求配置**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/preGoodsListForNdgTally`
 */
const postPreGoodsListForNdgTallyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/NoDataGoods/preGoodsListForNdgTally",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPreGoodsListForNdgTally",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓无数据点货商品列表 的 **请求函数**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/preGoodsListForNdgTally`
 */
export const postPreGoodsListForNdgTally = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postPreGoodsListForNdgTallyRequestConfig, requestData),
    ...args
  );
};
postPreGoodsListForNdgTally.requestConfig =
  postPreGoodsListForNdgTallyRequestConfig;
/**
 * 接口 前置仓无数据点货商品数据 的 **请求配置**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/getPreGoodsInfoForNdgDaBiao`
 */
const postGetPreGoodsInfoForNdgDaBiaoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/NoDataGoods/getPreGoodsInfoForNdgDaBiao",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPreGoodsInfoForNdgDaBiao",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓无数据点货商品数据 的 **请求函数**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/getPreGoodsInfoForNdgDaBiao`
 */
export const postGetPreGoodsInfoForNdgDaBiao = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPreGoodsInfoForNdgDaBiaoRequestConfig, requestData),
    ...args
  );
};
postGetPreGoodsInfoForNdgDaBiao.requestConfig =
  postGetPreGoodsInfoForNdgDaBiaoRequestConfig;
/**
 * 接口 前置仓无数据点货打标 的 **请求配置**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/preDabiaoForNdg`
 */
const postPreDabiaoForNdgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/NoDataGoods/preDabiaoForNdg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPreDabiaoForNdg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓无数据点货打标 的 **请求函数**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/preDabiaoForNdg`
 */
export const postPreDabiaoForNdg = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postPreDabiaoForNdgRequestConfig, requestData),
    ...args
  );
};
postPreDabiaoForNdg.requestConfig = postPreDabiaoForNdgRequestConfig;
/**
 * 接口 前置仓无数据点货获取打标中的数据 的 **请求配置**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/getPreDaBiaoIngForNdg`
 */
const postGetPreDaBiaoIngForNdgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/NoDataGoods/getPreDaBiaoIngForNdg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPreDaBiaoIngForNdg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓无数据点货获取打标中的数据 的 **请求函数**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/getPreDaBiaoIngForNdg`
 */
export const postGetPreDaBiaoIngForNdg = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPreDaBiaoIngForNdgRequestConfig, requestData),
    ...args
  );
};
postGetPreDaBiaoIngForNdg.requestConfig =
  postGetPreDaBiaoIngForNdgRequestConfig;
/**
 * 接口 前置仓无数据点货撤标 的 **请求配置**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/recallForPreNdg`
 */
const postRecallForPreNdgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/NoDataGoods/recallForPreNdg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postRecallForPreNdg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓无数据点货撤标 的 **请求函数**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/recallForPreNdg`
 */
export const postRecallForPreNdg = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postRecallForPreNdgRequestConfig, requestData),
    ...args
  );
};
postRecallForPreNdg.requestConfig = postRecallForPreNdgRequestConfig;
/**
 * 接口 前置仓无数据点货关联无数据标 的 **请求配置**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/toRealationPreNdgid`
 */
const postToRealationPreNdgidRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/NoDataGoods/toRealationPreNdgid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postToRealationPreNdgid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓无数据点货关联无数据标 的 **请求函数**
 *
 * @分类 #5367
 * @请求头 `POST /erp/NoDataGoods/toRealationPreNdgid`
 */
export const postToRealationPreNdgid = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postToRealationPreNdgidRequestConfig, requestData),
    ...args
  );
};
postToRealationPreNdgid.requestConfig = postToRealationPreNdgidRequestConfig;
const mockUrl_0_0_0_7 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_7 = "";
const prodUrl_0_0_0_7 = "";
const dataKey_0_0_0_7 = "data";
/**
 * 接口 从无数据id获取供应商 的 **请求配置**
 *
 * @分类 5802
 * @请求头 `POST /erp/NoDataGoods/getSupplyByNdgid`
 */
const postGetSupplyByNdgidRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/NoDataGoods/getSupplyByNdgid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyByNdgid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 从无数据id获取供应商 的 **请求函数**
 *
 * @分类 5802
 * @请求头 `POST /erp/NoDataGoods/getSupplyByNdgid`
 */
export const postGetSupplyByNdgid = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetSupplyByNdgidRequestConfig, requestData),
    ...args
  );
};
postGetSupplyByNdgid.requestConfig = postGetSupplyByNdgidRequestConfig;
/**
 * 接口 检查关联的无数据id是否正确 的 **请求配置**
 *
 * @分类 5802
 * @请求头 `POST /erp/NoDataGoods/checkNdgid`
 */
const postCheckNdgidRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/NoDataGoods/checkNdgid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckNdgid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 检查关联的无数据id是否正确 的 **请求函数**
 *
 * @分类 5802
 * @请求头 `POST /erp/NoDataGoods/checkNdgid`
 */
export const postCheckNdgid = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCheckNdgidRequestConfig, requestData), ...args);
};
postCheckNdgid.requestConfig = postCheckNdgidRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/noDataGoods.js